export const cities = [
  {
    id: 'kunming',
    name: 'Kunming',
    brief: `Pleasant spring city, green lakes and vibrant flower markets.`,
    image: '/images/cities/kunming/thumbnail.jpg',
    bannerImage: '/images/cities/kunming/banner.jpg',
    description: 'Kunming located in the middle of Yunnan, it not only as the capital of Yunnan but also is the economic and cultural center of Yunnan..Meanwhile it is well known for its nice climate all year around. The poem " climates remains like that of February and March, and flowers blossom throughout the year. " is the vividly depicts its climate of perennial spring and the reason why people like to call it as "eternal spring city ". Yuantong Temple and Stone forest is the must see attractions in Kunming.',
    mapImage: '/images/cities/kunming/map.jpg',
    relatedTours: ['best-of-yunnan', 'highlights-of-yunnan', '1-Day-Naigu-Stone-Forest'],
    attractions: {
      description: 'UNESCO World Heritage Stone Forest, Green Lake, Kunming Flowers and Birds Market.',
      places: [
        { name: 'Stone Forest', image: '/images/cities/kunming/attraction1.jpg' },
        { name: 'Green Lake', image: '/images/cities/kunming/attraction2.jpg' },
        { name: 'Western Hills', image: '/images/cities/kunming/attraction3.jpg' },
        { name: 'Old Street', image: '/images/cities/kunming/attraction4.jpg' },
        { name: 'Yuantong Temple', image: '/images/cities/kunming/attraction5.jpg' },
        { name: 'Jiuxiang Cave', image: '/images/cities/kunming/attraction6.jpg' }
      ]
    },
    minorities: {
      description: 'Kunming is home to a rich mosaic of ethnic groups, each with their own customs, languages, and traditions. Yi People in Stone forest area : Famous for their vibrant festivals and unique clothing.',
      groups: [
        { name: 'Yi Minority', image: '/images/cities/kunming/minority1.jpg' },
        { name: 'Bai Minority', image: '/images/cities/kunming/minority2.jpg' },
        { name: 'Naxi Minority', image: '/images/cities/kunming/minority3.jpg' }
      ]
    },
    food: {
      description: `Kunming is also a paradise for food lovers. The city's cuisine is influenced by its diverse geography and ethnic groups, with a focus on fresh, flavorful ingredients and unique spices. Crossing the Bridge Rice Noodles (过桥米线): A Yunnan specialty, this dish features rice noodles served in a hot broth with an array of fresh ingredients.Steam Pot Chicken (汽锅鸡): A famous Yunnan dish where chicken is steamed in a special pot with a variety of herbs and spices.`,
      dishes: [
        { name: 'Across the Bridge Noodles', image: '/images/cities/kunming/food1.jpg' },
        { name: 'Steam Pot Chicken', image: '/images/cities/kunming/food2.jpg' },
        { name: 'Crispy - Crust Steamed Bun', image: '/images/cities/kunming/food3.jpg' }
      ]
    },
    tours: {
      description: `The related Kunming tour is perfect for travelers who want to explore Kunming's stunning natural landscapes. The Stone Forest is one of Yunnan's most famous attractions, and the nearby scenic areas add to the region's natural allure.`,
    }
  },
  {
    id: 'lijiang',
    name: 'Lijiang',
    brief: 'Cobblestone alleys, Naxi culture, Jade Dragon Snow Mountain backdrop.',
    image: '/images/cities/lijiang/thumbnail.jpg',
    bannerImage: '/images/cities/lijiang/banner.jpg',
    description: `Lijiang is a city that beautifully combines historical charm, cultural diversity, and natural splendor. It's renowned for its UNESCO World Heritage Site, the Old Town of Lijiang, which showcases a unique blend of historical architecture and an intricate ancient water-supply system. The area is also known for the Yulong Snow Mountain，The mountain range is renowned for its diverse landscapes, including glaciers, meadows, and forests. When visiting Lijiang, you will find a wonderful mix of historical sites, beautiful natural scenery, and unique cultural experiences.`,
    mapImage: '/images/cities/lijiang/map.jpg',
    relatedTours: ['8-day-of-yunnan-lijiang', 'best-of-yunnan', 'highlights-of-yunnan'],
    attractions: {
      description: `UNESCO World Heritage Site the Old Town of Lijiang, Jade Dragon Snow Mountain -A majestic mountain range with snow-capped peaks, offering breathtaking views, Shuhe old town, Baisha Village, Tiger leaping gorge. Three Parallel Rivers region, a UNESCO World Heritage site.`,
      places: [
        { name: 'Lijiang Old Town', image: '/images/cities/lijiang/attraction1.jpg' },
        { name: 'Jade Dragon Snow Mountain', image: '/images/cities/lijiang/attraction2.jpg' },
        { name: 'Impression Lijiang Show', image: '/images/cities/lijiang/attraction3.jpg' },
        { name: 'Shuhe Old town', image: '/images/cities/lijiang/attraction4.jpg' },
        { name: 'Baisha Old town', image: '/images/cities/lijiang/attraction5.jpg' },
        { name: 'Yuhu village', image: '/images/cities/lijiang/attraction6.jpg' }
      ]
    },
    minorities: {
      description: `Lijiang is a significant center for the Naxi people, an ethnic minority with a rich cultural heritage, including their own language and writing system Dongba script,a living pictographic writing system.`,
      groups: [
        { name: 'Naxi People', image: '/images/cities/lijiang/minority1.jpg' },
        { name: 'Naxi People', image: '/images/cities/lijiang/minority2.jpg' },
        { name: 'Naxi People', image: '/images/cities/lijiang/minority3.jpg' }
      ]
    },
    food: {
      description: `"Three Stacked Waters"-a traditional Naxi dining experience. It involves a series of dishes served in three courses, showcasing local snacks, cold dishes, and hot cooked dishes. Lijiang Baba - A Naxi-style pastry that comes in sweet and savory varieties`,
      dishes: [
        { name: 'Lijiang Baba', image: '/images/cities/lijiang/food1.jpg' },
        { name: 'Lijiang Cured Pork Chop', image: '/images/cities/lijiang/food2.jpg' },
        { name: 'Three Stacked Waters 三叠水宴', image: '/images/cities/lijiang/food3.jpg' }
      ]
    },
    tours: {
      description: `Our related Lijiang tours providing an immersive experience into the culture, history, and daily life of the Naxi people, with plenty of time to explore the ancient town and surrounding scenic areas.`,
    }
  },
  {
    id: 'dali',
    name: 'Dali',
    brief: 'Ancient Bai town beside serene Erhai Lake and mountains.',
    image: '/images/cities/dali/thumbnail.jpg',
    bannerImage: '/images/cities/dali/banner.jpg',
    description: `Nestled between the majestic Cangshan Mountains and the serene Erhai Lake, Dali is a captivating town located in the western part of Yunnan Province. Known for its stunning natural landscapes, rich cultural heritage, and relaxed atmosphere, Dali is a perfect destination for travelers seeking a blend of history, outdoor adventure, and authentic local culture. Historically a center of the Bai people's kingdom, Dali is steeped in ancient traditions and stunning architecture. The town's charming streets, bustling markets, and nearby scenic spots make it an ideal destination for travelers looking to experience the heart of Yunnan.`,
    mapImage: '/images/cities/dali/map.jpg',
    relatedTours: ['6-day-of-yunnan', 'best-of-yunnan', 'highlights-of-yunnan'],
    attractions: {
      description: 'Dali Old Town, Erhai Lake, Three Pagodas of Chongsheng Temple, Xizhou Town, Zhoucheng Village, Shaxi old town with Shibaoshan Grottoes',
      places: [
        { name: 'Dali Old Town', image: '/images/cities/dali/attraction1.jpg' },
        { name: 'Xizhou Town', image: '/images/cities/dali/attraction2.jpg' },
        { name: 'Zhoucheng Village', image: '/images/cities/dali/attraction3.jpg' },
        { name: 'Shaxi Old Town', image: '/images/cities/dali/attraction4.jpg' },
        { name: 'Shibaoshan Grottoes', image: '/images/cities/dali/attraction5.jpg' },
        { name: 'Erhai Lake', image: '/images/cities/dali/attraction6.jpg' }
      ]
    },
    minorities: {
      description: `Dali is home to the Bai people. The Bai have a distinct language, clothing, and culture, which can be seen in their architecture, food, and festivals. Dali is also home to other ethnic groups, such as the Yi, Hui, and Naxi peoples, who have their own unique cultural traditions.`,
      groups: [
        { name: 'Bai People', image: '/images/cities/dali/minority1.jpg' },
        { name: 'Bai People', image: '/images/cities/dali/minority2.jpg' },
        { name: 'Bai People', image: '/images/cities/dali/minority3.jpg' }
      ]
    },
    food: {
      description: `Dali's cuisine is influenced by the fresh ingredients from the surrounding mountains and lakes, with a particular focus on local herbs, vegetables, and fish from Erhai Lake. Bai-style Fish: Fish from Erhai Lake, typically cooked in a simple yet flavorful style, with herbs and spices. Dali Cheese: Known locally as "yunnan-style cheese," this dish is often paired with chili sauce or added to soups and hotpots.`,
      dishes: [
        { name: 'Bai-style Fish', image: '/images/cities/dali/food1.jpg' },
        { name: 'Dali Baba', image: '/images/cities/dali/food2.jpg' },
        { name: 'Grilled Rushan', image: '/images/cities/dali/food3.jpg' }
      ]
    },
    tours: {
      description: `Our tour to Dali is perfect for travelers who are interested in exploring the cultural heritage of Dali. It provides a deeper understanding of the diverse ethnic cultures in Yunnan and offers a chance to visit one of the province's most iconic destinations.`,
    }
  },
  {
    id: 'yuanyang',
    name: 'Yuanyang',
    brief: 'Spectacular terraced rice fields glowing at sunrise and sunset.',
    image: '/images/cities/yuanyang/thumbnail.jpg',
    bannerImage: '/images/cities/yuanyang/banner.jpg',
    description: `Located in the southern part of Yunnan Province, Yuanyang is a breathtaking region known for its iconic terraced rice fields, which stretch across the landscape like an intricate work of art. The area is not only famous for its natural beauty but also for its rich cultural heritage, particularly the traditions of the Hani people, who have lived in this area for centuries.Yuanyang is one of the best destinations in China for photography, offering dramatic landscapes that change with the seasons—from the lush green fields of spring to the golden hues of autumn. As a UNESCO World Heritage Site, the Yuanyang Rice Terraces are a must-see for any traveler to Yunnan.`,
    mapImage: '/images/cities/yuanyang/map.jpg',
    relatedTours: ['5-day-of-yunnan', 'highlights-of-yunnan', 'circuit-real-yunnan'],
    attractions: {
      description: 'YYuanyang Rice Terraces, Qingkou Hani Village',
      places: [
        { name: 'Tiger Mouth Sunset', image: '/images/cities/yuanyang/attraction1.jpg' },
        { name: 'Duoyi Village Sunrise ', image: '/images/cities/yuanyang/attraction2.jpg' },
        { name: 'Qingkou Hani Village', image: '/images/cities/yuanyang/attraction3.jpg' },
        { name: 'Bada Village', image: '/images/cities/yuanyang/attraction4.jpg' },
        { name: 'Azheke Village', image: '/images/cities/yuanyang/attraction5.jpg' },
        { name: 'Yuanyang Local market', image: '/images/cities/yuanyang/attraction6.jpg' }
      ]
    },
    minorities: {
      description: 'Yuanyang is home to a variety of ethnic groups, with the Hani people being the most prominent. The Hani are known for their agricultural skills, especially in cultivating rice, and their colorful, traditional clothing. Other ethnic groups living in the region include the Yi, Zhuang, and Miao people, each with their own unique customs and languages.',
      groups: [
        { name: 'Hani People', image: '/images/cities/yuanyang/minority1.jpg' },
        { name: 'Hani People', image: '/images/cities/yuanyang/minority2.jpg' },
        { name: 'Hani People', image: '/images/cities/yuanyang/minority3.jpg' }
      ]
    },
    food: {
      description: `Yuanyang's cuisine is deeply influenced by its rural and ethnic cultures, with a focus on fresh, locally grown ingredients. Here are some must-try dishes: Hani-style Rice Noodles: A signature dish of the Hani people, these rice noodles are served with a spicy broth and accompanied by pickled vegetables and meats. Rice-based Dishes: Given the abundance of rice in the region, various rice-based dishes, such as steamed rice with vegetables and Hani-style sticky rice, are commonly found in local restaurants.`,
      dishes: [
        { name: 'Rice-based Dishes 梯田红米饭', image: '/images/cities/yuanyang/food1.jpg' },
        { name: 'Hani-style Rice Noodles', image: '/images/cities/yuanyang/food2.jpg' },
        { name: 'Dipping Saucing Chicken', image: '/images/cities/yuanyang/food3.jpg' }
      ]
    },
    tours: {
      description: `These tour in Yuanyang will guide you through the must-see attractions and experiences in Yuanyang.`,
    }
  },
  {
    id: 'shangri-la',
    name: 'Shangri-La',
    brief: 'Tibetan highland paradise with monasteries, meadows, and prayer flags.',
    image: '/images/cities/shangri-la/thumbnail.jpg',
    bannerImage: '/images/cities/shangri-la/banner.jpg',
    description: `Shangri-La, a name that evokes images of an idyllic, hidden paradise, is located in the northwestern part of Yunnan Province in China. Known for its breathtaking landscapes, rich Tibetan culture, and spiritual atmosphere, Shangri-La is a must-visit destination for travelers seeking both adventure and tranquility. The area, which lies on the Tibetan Plateau, is home to snow-capped mountains, lush meadows, crystal-clear lakes, and unique Tibetan monasteries, offering a perfect escape from the hustle and bustle of city life.`,
    mapImage: '/images/cities/shangri-la/map.jpg',
    relatedTours: ['6-day-of-yunnan', 'best-of-yunnan', 'highlights-of-yunnan'],
    attractions: {
      description: 'Pudacuo National Park, Songzanlin Monastery (Ganden Sumtseling Monastery), Napahai Wetland',
      places: [
        { name: 'Songzanlin Monastery', image: '/images/cities/shangri-la/attraction1.jpg' },
        { name: 'Pudacuo National Park', image: '/images/cities/shangri-la/attraction2.jpg' },
        { name: 'Napahai Wetland', image: '/images/cities/shangri-la/attraction3.jpg' },
        { name: 'Dukezong Old Town ', image: '/images/cities/shangri-la/attraction4.jpg' },
        { name: 'Tiger Leaping Gorge ', image: '/images/cities/shangri-la/attraction5.jpg' },
        { name: 'Largest Pray Wheel in The World', image: '/images/cities/shangri-la/attraction6.jpg' }
      ]
    },
    minorities: {
      description: `Shangri-La is home to a rich blend of ethnic groups, with the Tibetan people being the predominant population. Tibetan culture is deeply woven into the daily life here, from the local markets to religious festivals, and can be experienced through the architecture, food, and traditions.`,
      groups: [
        { name: 'Tibetan People', image: '/images/cities/shangri-la/minority1.jpg' },
        { name: 'Tibetan People', image: '/images/cities/shangri-la/minority2.jpg' },
        { name: 'Tibetan People', image: '/images/cities/shangri-la/minority3.jpg' }
      ]
    },
    food: {
      description: `Shangri-La''s cuisine reflects the Tibetan lifestyle, with hearty and warming dishes designed to withstand the high-altitude cold. Here are some must-try foods during your visit: Tibetan Hotpot (Mutton Hotpot) A traditional hotpot made with lamb or beef, cooked in a flavorful broth along with a variety of vegetables. This dish is ideal for cold nights in Shangri-La. Butter Tea (Po Cha) A unique and traditional Tibetan drink made with tea, butter, and salt. While it may be unfamiliar to many Western travelers, butter tea is an essential part of Tibetan culture and hospitality.`,
      dishes: [
        { name: 'Tibetan Hotpot', image: '/images/cities/shangri-la/food1.jpg' },
        { name: 'Butter Tea', image: '/images/cities/shangri-la/food2.jpg' },
        { name: 'Highland Barley Wine', image: '/images/cities/shangri-la/food3.jpg' }
      ]
    },
    tours: {
      description: `Shangri-la tous by Real Yunnan combines the best cultural and natural attractions of the region. It's a great way to immerse yourself in the Tibetan way of life while enjoying spectacular scenery.`,
    }
  },
  {
    id: 'puer',
    name: 'Pu\'er',
    brief: `Lush tea mountains, mellow brews, and slow-paced subtropical countryside.`,
    image: '/images/cities/puer/thumbnail.jpg',
    bannerImage: '/images/cities/puer/banner.jpg',
    description: `Nestled in the southern part of Yunnan Province, Pu'er is a city renowned worldwide for its rich history of tea production, breathtaking landscapes, and diverse ethnic culture. Often called the "Tea Capital of the World," Pu'er has long been famous for its ancient tea trees, particularly the prized Pu'er tea, which is considered one of the best in China. In addition to its tea legacy, Pu'er offers visitors a chance to explore lush rainforests, visit unique ethnic minority villages, and immerse themselves in the traditional way of life in one of China''s most culturally rich regions.`,
    mapImage: '/images/cities/puer/map.jpg',
    relatedTours: ['4-day-tea-culture-tour-in-yunnan', '7-day-tea-culture-tour-in-yunnan', '15-day-tea-culture-tour-in-yunnan'],
    attractions: {
      description: `Pu'er Tea Plantations, Ximeng (Ximeng Township), Menghai Tea Garden, Pu'er Forest Park,Manhao Village`,
      places: [
        { name: `Pu'er Tea Expo`, image: '/images/cities/puer/attraction1.jpg' },
        { name: `Pu'er Sun River National Forest Park`, image: '/images/cities/puer/attraction2.jpg' },
        { name: 'Nakeli Tea Horse Guest House', image: '/images/cities/puer/attraction3.jpg' },
        { name: 'Bulang Minority Bonfire Party', image: '/images/cities/puer/attraction4.jpg' },
        { name: 'Nuogan Ancient Village', image: '/images/cities/puer/attraction5.jpg' },
        { name: 'Shangcheng Temple', image: '/images/cities/puer/attraction6.jpg' }
      ]
    },
    minorities: {
      description: `There's 25 ethics in Pu'er. Wa is the main ethnic group with their unique custom and culture.`,
      groups: [
        { name: 'Wa People', image: '/images/cities/puer/minority1.jpg' },
        { name: 'Hani People', image: '/images/cities/puer/minority2.jpg' },
        { name: 'Bulang People', image: '/images/cities/puer/minority3.jpg' }
      ]
    },
    food: {
      description: `Pu'er's cuisine is influenced by its ethnic diversity, and the local dishes often feature fresh, locally sourced ingredients. Here are some must-try foods when visiting Pu'er: Pu'er Tea: Of course, no visit to Pu'er is complete without trying its famous tea. Sample different varieties of aged Pu'er tea, a unique and prized tea that improves with age, offering a rich, earthy flavor. Pu'er-style Hotpot: A local variation of the traditional hotpot, it's made with fresh meats, vegetables, and herbs. It's a fun and social way to dine with friends and family. Bamboo Rice: A unique dish made with rice and other local ingredients wrapped in bamboo, offering a smoky and earthy flavor.`,
      dishes: [
        { name: `Pu'er roast chicken`, image: '/images/cities/puer/food1.jpg' },
        { name: 'Roast Meat Dishes with Glutinous Rice', image: '/images/cities/puer/food2.jpg' },
        { name: 'Roast Glutinous Rice Cake', image: '/images/cities/puer/food3.jpg' }
      ]
    },
    tours: {
      description: `Pu'er is a hidden gem in southern Yunnan, real Yunnan offers an unparalleled opportunity to immerse yourself in the world of tea cultivation, explore ancient ethnic minority villages, and experience breathtaking natural beauty. This tour will take you through the lush tea plantations, remote villages, and cultural sites that make Pu'er one of Yunnan's most intriguing destinations.`,
    }
  },
  {
    id: 'jianshui',
    name: 'Jianshui',
    brief: 'Historic Ming architecture, intricate temples, and timeworn purple pottery.',
    image: '/images/cities/jianshui/thumbnail.jpg',
    bannerImage: '/images/cities/jianshui/banner.jpg',
    description: 'Jianshui is in south part of Yunnan being an ancient cultural city and important gateway. Jianshui also boasts of more than fifty well-preserved old architectures, and is deemed as a live museum of folk residences and ancient architectures.Jianshui offers a unique blend of history, culture, and natural beauty, making it a perfect destination for those looking to explore the heart of Yunnan.',
    mapImage: '/images/cities/jianshui/map.jpg',
    relatedTours: ['5-day-of-yunnan', 'highlights-of-yunnan', 'circuit-real-yunnan'],
    attractions: {
      description: 'The city has rich cultural relics such as the Chaoyang Gateway Arch, the Jianshui Confucious Temple, the Zhilin Temple, Shuanglong Bridge, the Private Garden of the Zhu Family and the Ancient Wells scattering in the old town.',
      places: [
        { name: 'Tuanshan Village', image: '/images/cities/jianshui/attraction1.jpg' },
        { name: 'Chaoyang Tower', image: '/images/cities/jianshui/attraction2.jpg' },
        { name: 'Old Area of Jiasnhui', image: '/images/cities/jianshui/attraction3.jpg' },
        { name: 'Jianshui Confucius Temple', image: '/images/cities/jianshui/attraction4.jpg' },
        { name: `Family Zhu's Garden`, image: '/images/cities/jianshui/attraction5.jpg' },
        { name: 'Daban Well', image: '/images/cities/jianshui/attraction6.jpg' }
      ]
    },
    minorities: {
      description: `Jianshui is the living place for Hani and Yi minorities which inherit for hundreds of years.`,
      groups: [
        { name: 'Hani People', image: '/images/cities/jianshui/minority1.jpg' },
        { name: 'Hani People', image: '/images/cities/jianshui/minority2.jpg' },
        { name: 'Hani People', image: '/images/cities/jianshui/minority3.jpg' }
      ]
    },
    food: {
      description: 'The Jianshui food enjoys a good reputation, especially local barbecue and Steam Pot Chicken.',
      dishes: [
        { name: 'Jianshui Barbecue', image: '/images/cities/jianshui/food1.jpg' },
        { name: 'Steam Pot Chicken', image: '/images/cities/jianshui/food2.jpg' },
        { name: 'Jianshui Tofu', image: '/images/cities/jianshui/food3.jpg' }
      ]
    },
    tours: {
      description: `These tour in Jianshui will guide you through the must-see attractions and experiences in Jianshui.`,
    }
  },
  {
    id: 'deqin',
    name: 'Deqin',
    brief: `Snowy Meili peaks, sacred glaciers, dramatic Mekong gorge vistas.`,
    image: '/images/cities/deqin/thumbnail.jpg',
    bannerImage: '/images/cities/deqin/banner.jpg',
    description: `Located in the heart of Yunnan Province, Deqing is an often-overlooked gem that offers a blend of stunning landscapes, rich cultural heritage, and ethnic diversity. Known for its picturesque mountains, tranquil rivers, and vibrant minority cultures. The area is home to several ethnic groups, such as the Tibetan, Naxi, Yi, and Lisu peoples, each with their own distinct traditions, art, and architecture. Deqin is also renowned for its natural beauty, offering travelers a chance to explore lush forests, serene lakes, and majestic mountains, making it a perfect destination for nature lovers and cultural enthusiasts alike.`,
    mapImage: '/images/cities/deqin/map.jpg',
    relatedTours: ['discover-real-yunnan', 'highlights-of-yunnan', 'circuit-real-yunnan'],
    attractions: {
      description: 'Mt. Meili Snow Mountain (Meili Xue Shan), The Jinsha River, Deqing Tibetan Monasteries',
      places: [
        { name: 'The Great Jingsha River Corner', image: '/images/cities/deqin/attraction1.jpg' },
        { name: 'Dongzhulin monastery', image: '/images/cities/deqin/attraction2.jpg' },
        { name: 'Baiman Snow Mountain', image: '/images/cities/deqin/attraction3.jpg' },
        { name: 'Sunrise of Meili Snow Mountain', image: '/images/cities/deqin/attraction4.jpg' },
        { name: 'Feilaisi Temple', image: '/images/cities/deqin/attraction5.jpg' },
        { name: 'Mingyong Glacier', image: '/images/cities/deqin/attraction6.jpg' }
      ]
    },
    minorities: {
      description: `Tibetan: The Tibetan people are the largest ethnic group in Deqing. Their culture is deeply influenced by Tibetan Buddhism, and their monasteries, rituals, and festivals offer insight into one of the world's most fascinating spiritual traditions.`,
      groups: [
        { name: 'Tibetan People', image: '/images/cities/deqin/minority1.jpg' },
        { name: 'Tibetan People', image: '/images/cities/deqin/minority2.jpg' },
        { name: 'Tibetan People', image: '/images/cities/deqin/minority3.jpg' }
      ]
    },
    food: {
      description: `The cuisine in Deqing is heavily influenced by its Tibetan, Naxi, and Yi communities. Traditional dishes are often hearty, with an emphasis on meat, dairy, and local vegetables. Here are some must-try dishes: Tibetan Butter Tea (Pocha): A staple in Tibetan households, this tea is made with yak butter, tea leaves, and salt, creating a rich and savory flavor. Yak Meat: Known for its tender texture, yak meat is a local delicacy in Deqing. It's often served in stews, grilled, or used in traditional hotpot.`,
      dishes: [
        { name: 'Tibetan Hotpot', image: '/images/cities/deqin/food1.jpg' },
        { name: 'Butter Tea', image: '/images/cities/deqin/food2.jpg' },
        { name: 'Highland Barley Wine', image: '/images/cities/deqin/food3.jpg' }
      ]
    },
    tours: {
      description: `Here's a curated selection of Deqin County tour packages by real Yunnan that cater to international travelers, emphasizing the region's natural beauty, Tibetan culture, and trekking opportunities.`,
    }
  }
];

export function getToursForCity(cityId) {
  // This function would fetch relevant tours for a specific city
  // In a real application, this might access an API or database
  // For now, it returns a placeholder
  return [];
} 